export const findSignUpErrorMessage = (statuscode) => {
    switch (statuscode) {
        case 400:
            return (
                <p>Der Benutzername oder die Emailadresse sind bereits vergeben. Bitte versuchen Sie es mit anderen Eingaben erneut!</p>
            );
        default:
            return 'Something went wrong';
    }
};